import {
  FETCH_VERTICALS,
  FETCH_VERTICALS_SUCCESS,
  FETCH_VERTICALS_FAILURE,
  FETCH_SELENE_VERSIONS,
  FETCH_SELENE_VERSIONS_SUCCESS,
  FETCH_SELENE_VERSIONS_FAILURE,
  FETCH_TEMPLATE_TYPES,
  FETCH_TEMPLATE_TYPES_SUCCESS,
  FETCH_TEMPLATE_TYPES_FAILURE,
  FETCH_VERTICAL_STATUS,
  FETCH_VERTICAL_STATUS_SUCCESS,
  FETCH_VERTICAL_STATUS_FAILURE,
  FETCH_VERTICAL_PROGRESS,
  FETCH_VERTICAL_PROGRESS_SUCCESS,
  FETCH_VERTICAL_PROGRESS_FAILURE,
  REINDEX_VERTICAL,
  REINDEX_VERTICAL_SUCCESS,
  REINDEX_VERTICAL_FAILURE,
  STOP_SELENE_REINDEX,
  STOP_SELENE_REINDEX_SUCCESS,
  STOP_SELENE_REINDEX_FAILURE,
  REINDEX_SELENE_BY_ID,
  REINDEX_SELENE_BY_ID_SUCCESS,
  REINDEX_SELENE_BY_ID_FAILURE,
  SET_SELENE_VERSIONS,
  SET_SELENE_VERSIONS_SUCCESS,
  SET_SELENE_VERSIONS_FAILURE,
  SET_TEMPLATE_TYPES,
} from './types'

export const fetchVerticals = (accessToken) => ({
  type: FETCH_VERTICALS,
  payload: { accessToken },
})

export const fetchVerticalsSuccess = (verticals) => ({
  type: FETCH_VERTICALS_SUCCESS,
  payload: verticals,
})

export const fetchVerticalsFailure = (error) => ({
  type: FETCH_VERTICALS_FAILURE,
  payload: error,
})

export const fetchVersions = (accessToken) => ({
  type: FETCH_SELENE_VERSIONS,
  payload: { accessToken },
})

export const fetchVersionsSuccess = (versions) => ({
  type: FETCH_SELENE_VERSIONS_SUCCESS,
  payload: versions,
})

export const fetchVersionsFailure = (error) => ({
  type: FETCH_SELENE_VERSIONS_FAILURE,
  payload: error,
})

export const fetchTemplateTypes = (accessToken) => ({
  type: FETCH_TEMPLATE_TYPES,
  payload: { accessToken },
})

export const fetchTemplateTypesSuccess = (templateTypes) => ({
  type: FETCH_TEMPLATE_TYPES_SUCCESS,
  payload: templateTypes,
})

export const fetchTemplateTypesFailure = (error) => ({
  type: FETCH_TEMPLATE_TYPES_FAILURE,
  payload: error,
})

export const fetchVerticalStatus = (verticalName, indexName, templateTypes, accessToken) => ({
  type: FETCH_VERTICAL_STATUS,
  payload: { verticalName, indexName, templateTypes, accessToken },
})

export const fetchVerticalStatusSuccess = (verticalName, indexName, data) => ({
  type: FETCH_VERTICAL_STATUS_SUCCESS,
  payload: { verticalName, indexName, data },
})

export const fetchVerticalStatusFailure = (verticalName, indexName, error) => ({
  type: FETCH_VERTICAL_STATUS_FAILURE,
  payload: { verticalName, indexName, error },
})

export const fetchVerticalProgress = (verticalName, accessToken) => ({
  type: FETCH_VERTICAL_PROGRESS,
  payload: { verticalName, accessToken },
})

export const fetchVerticalProgressSuccess = (verticalName, data) => ({
  type: FETCH_VERTICAL_PROGRESS_SUCCESS,
  payload: { verticalName, data },
})

export const fetchVerticalProgressFailure = (verticalName, error) => ({
  type: FETCH_VERTICAL_PROGRESS_FAILURE,
  payload: { verticalName, error },
})

export const reindexVertical = (verticalName, templateTypes, accessToken) => ({
  type: REINDEX_VERTICAL,
  payload: { verticalName, templateTypes, accessToken },
})

export const reindexVerticalSuccess = (verticalName) => ({
  type: REINDEX_VERTICAL_SUCCESS,
  payload: verticalName,
})

export const reindexVerticalFailure = (verticalName, error) => ({
  type: REINDEX_VERTICAL_FAILURE,
  payload: { verticalName, error },
})

export const stopReindex = (verticalName, accessToken) => ({
  type: STOP_SELENE_REINDEX,
  payload: { verticalName, accessToken },
})

export const stopReindexSuccess = (verticalName) => ({
  type: STOP_SELENE_REINDEX_SUCCESS,
  payload: verticalName,
})

export const stopReindexFailure = (verticalName, error) => ({
  type: STOP_SELENE_REINDEX_FAILURE,
  payload: { verticalName, error },
})

export const setVersions = (versions, accessToken) => ({
  type: SET_SELENE_VERSIONS,
  payload: { versions, accessToken },
})

export const setVersionsSuccess = () => ({
  type: SET_SELENE_VERSIONS_SUCCESS,
})

export const setVersionsFailure = (error) => ({
  type: SET_SELENE_VERSIONS_FAILURE,
  payload: error,
})

export const reindexById = (documentIds, accessToken) => ({
  type: REINDEX_SELENE_BY_ID,
  payload: { documentIds, accessToken },
})

export const reindexByIdSuccess = () => ({
  type: REINDEX_SELENE_BY_ID_SUCCESS,
})

export const reindexByIdFailure = (error) => ({
  type: REINDEX_SELENE_BY_ID_FAILURE,
  payload: error,
})

export const setTemplateTypes = (templateTypes, accessToken) => ({
  type: SET_TEMPLATE_TYPES,
  payload: { templateTypes, accessToken },
})
